// extracted by mini-css-extract-plugin
export default {"title":"a74be307ce","bld":"_00eb5bd6dc"};